import React, { useState, useEffect } from "react";
import { Image } from "@sitecore-jss/sitecore-jss-react";
import { withTranslation } from "react-i18next";
import DiaperLandingData from "./diaper-calculator-landing/DiaperLandingData";
import { dataFetcher, postDataFetcher } from "../../dataFetcher";
import CONFIG_OBJECT from "../../config/config";
import "./diaper-calculator-css/diaper-calculator.css";
import Results from "./diaper-calculator-result/Results";
import configData from "../../temp/config";
import App_Constants from "../../app-constants/App_Constants";
import { isMobile } from "react-device-detect";
import DC_Constants from "./DC_Constants";

let diaperCalcData = {
  eventType: "",
  numberOfGuests: 0,
  pkgPerPerson: 0,
  weight: 0,
  period: 0,
  weightUnitKgs: true,
};

const DiaperCalculatorCalculation = (props) => {
  const [disableBtn, setDisableBtn] = useState(true);
  const [componentData, setComponentData] = useState({});
  const [showButton, setShowButton] = useState(false);
  const [showOnMobile, setShowOnMobile] = useState(true);
  const [isReset, setIsReset] = useState(false);
  const [diaperCalculatorData, setDiaperCalculatorData] = useState({
    showTripResult: false,
    showTeaResult: false,
    showResult: false,
    apiData: {},
  });

  useEffect(() => {
    setComponentData(props.fields);
    // checkDropDown();
  }, []);

  const calculateDiaper = () => {
    console.log("Button status" + disableBtn);
    if (!disableBtn) {
      document.getElementsByName("calculate-button")[0].focus();
      let isMobileView = isMobile;
      setDisableBtn(true);
      // setShowResult(true);
      let data = {};
      let restUrl = "";

      if (diaperCalcData.eventType === "Trip") {
        restUrl = `${CONFIG_OBJECT.DC_TRIP_REST_URL_V2}`;
        data = {
          EventId: `{${componentData.eventDropDownList[1].id}}`,
          NoofDays: diaperCalcData.period,
          Babyweight: diaperCalcData.weight,
          WeightUnit: diaperCalcData.weightUnitKgs
            ? diaperCalcData.kgsguid
            : diaperCalcData.lbsguid,
        };
      } else {
        restUrl = `${CONFIG_OBJECT.DC_TEA_REST_URL}`;
        data = {
          EventId: `{${componentData.eventDropDownList[0].id}}`,
          NoofGuests: Number(diaperCalcData.numberOfGuests),
          PacksPerGuest: Number(diaperCalcData.pkgPerPerson),
        };
      }

      if (isMobileView) {
        setIsReset(false);
        setShowOnMobile(false);
        document.getElementById("diaper-form").style.display = "none";
      }
      // Calling REST API Url
      postDataFetcher(`${restUrl}${App_Constants.SC_API_KEY}`, data).then(
        (res) => {
          setDiaperCalculatorData({
            showTeaResult: diaperCalcData.eventType === "Trip" ? false : true,
            showTripResult: diaperCalcData.eventType === "Trip" ? true : false,
            apiData: res.data.Data,
          });
        }
      );
      // document.getElementById("calculate-button-id").disabled = true;
    }
  };

  const showMainMenu = () => {
    // setShowOnMobile(true);
    document.getElementById("diaper-form").style.display = "";
    setIsReset(true);
    setDiaperCalculatorData({
      showTeaResult: false,
      showTripResult: false,
    });
  };

  const sendLastPeriodData = (
    eventType,
    numberOfGuests,
    pkgPerPerson,
    weight,
    period,
    dropDownSelector,
    weightUnitKgs,
    lbsguid,
    kgsguid
  ) => {
    diaperCalcData = {
      eventType: eventType,
      numberOfGuests: numberOfGuests,
      pkgPerPerson: pkgPerPerson,
      weight: weight,
      period: period,
      weightUnitKgs: weightUnitKgs,
      lbsguid: lbsguid,
      kgsguid: kgsguid,
    };
    let checkEventType = componentData.eventDropDownList.filter((item) => {
      if (item.fields.eventName.value === eventType) return item;
    });

    if (checkEventType.length > 0) {
      setShowButton(true);
      if (
        Number(diaperCalcData.numberOfGuests) !== 0 &&
        Number(diaperCalcData.pkgPerPerson) !== 0
      ) {
        setDisableBtn(false);
      } else if (
        Number(diaperCalcData.weight) !== 0 &&
        Number(diaperCalcData.period) !== 0
      ) {
        setDisableBtn(false);
      } else {
        setDisableBtn(true);
      }
    } else {
      setShowButton(false);
    }
    if (
      dropDownSelector === componentData.eventDropDownDefaultText.value ||
      dropDownSelector ===
        componentData.eventDropDownList[0].fields.eventName.value ||
      dropDownSelector ===
        componentData.eventDropDownList[1].fields.eventName.value
    ) {
      // To disable calculate button by default once we select the event from dropdown with already filled input
      setDisableBtn(true);
      setDiaperCalculatorData({
        showTeaResult: false,
        showTripResult: false,
      });
    }
  };

  const mySubmitHandler = (e) => {
    e.preventDefault();
  };

  if (componentData.guestTitle) {
    return (
      // <div className="container-fluid">
      <section className="diaper-calc-wrap">
        <div className="container p-0">
          <div className="row">
            <div className="col-12">
              <div className="diaper-calculator">
                {/* <header>
                  <img src={`${configData.sitecoreApiHost}${componentData.brandLogo.value.src}`} alt="" />
                </header>
                <div className="heading-section ">
                  <img src={`${configData.sitecoreApiHost}${componentData.topLogo.value.src}`} alt="" />
                  <h1>{componentData.title.value}</h1>
                </div> */}
                <div className="main-section" id="diaper-form">
                  <p className={isMobile ? "d-none" : ""}>
                    {componentData.description.value}
                  </p>
                  <form onSubmit={mySubmitHandler} noValidate>
                    <DiaperLandingData
                      sendLastPeriodData={sendLastPeriodData}
                      componentData={componentData}
                      isReset={isReset}
                      calculateDiaper={calculateDiaper}
                    />
                    {showButton && (
                      <div className="btn-block">
                        <button
                          type="submit"
                          name="calculate-button"
                          className="calculate"
                          onClick={calculateDiaper}
                          disabled={disableBtn}
                        >
                          {componentData.buttonLabel.value}
                        </button>
                      </div>
                    )}
                  </form>
                </div>
                {(diaperCalculatorData.showTeaResult ||
                  diaperCalculatorData.showTripResult) && (
                  <Results
                    isMobile={isMobile}
                    showMainMenu={showMainMenu}
                    componentData={componentData}
                    diaperCalculatorData={diaperCalculatorData.apiData}
                    diaperCalcData={diaperCalcData}
                  />
                )}

                {/* <footer>
                  <p>{componentData.footerText.value}</p>
                </footer> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return <></>;
  }
};

export default DiaperCalculatorCalculation;
